import $ from "jquery"
import Chart from "chart.js/auto"

globalThis.$ = $
globalThis.jQuery = $
globalThis.Chart = Chart

// アクティブなタブが見えるようにスクロールコンテナを自動スクロール
function scrollActiveTabIntoView() {
  document.querySelectorAll(".js-scroll-active-wrap").forEach(wrap => {
    const active = wrap.querySelector(".js-scroll-active")
    if (!active) return

    // アクティブ要素の左端をコンテナの中央に揃える
    const wrapLeft = wrap.getBoundingClientRect().left
    const activeLeft = active.getBoundingClientRect().left
    const offset = activeLeft - wrapLeft - (wrap.clientWidth / 2) + (active.clientWidth / 2)
    wrap.scrollLeft = wrap.scrollLeft + offset
  })
}

document.addEventListener("turbo:load", scrollActiveTabIntoView)
document.addEventListener("DOMContentLoaded", scrollActiveTabIntoView)
